import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"

export const apiSlice = createApi({
    reducerPath: 'api',
    baseQuery: fetchBaseQuery({
        baseUrl: 'http://localhost:9000/',
    }),
    tagTypes: ["booksTag"],
    endpoints: (builder) => ({
        getBooks: builder.query({
            query: () => '/books',
            providesTags: ["booksTag"]

        }),
        addBook: builder.mutation({
            query: (book) => ({
                url: '/books',
                method: 'POST',
                body: book,
            }),
            invalidatesTags: ["booksTag"],
        }),
        deleteBook: builder.mutation({
            query: (bookId) => ({
                url: `/books/${bookId}`,
                method: 'DELETE',
            }),
            invalidatesTags: ["booksTag"],
        }),
        editBook: builder.mutation({
            query: ({ id, bookData }) => ({
                url: `/books/${id}`,
                method: 'PUT',
                body: bookData,
            }),
            invalidatesTags: ["booksTag"],
        }),
        getBookById: builder.query({
            query: (id) => `/books/${id}`,

        }),
    }),
});

export const { useGetBooksQuery, useAddBookMutation, useDeleteBookMutation, useGetBookByIdQuery, useEditBookMutation } = apiSlice;
